import toolsClient from "@/api/toolsClient";

export const getAutoDj = async (stationKey) => {
  const response = await toolsClient.get(`stations/${stationKey}/auto_dj/`);

  return response.data;
};

export const updateAutoDj = async ({ stationKey, data }) => {
  const response = await toolsClient.put(
    `stations/${stationKey}/auto_dj/`,
    data
  );

  return response.data;
};

export const restartPlaylist = async (stationKey) => {
  const response = await toolsClient.post(
    `stations/${stationKey}/auto_dj/reset/`
  );

  return response.data;
};

export const getCurrentPlaying = async (stationKey) => {
  const response = await toolsClient.get(
    `stations/${stationKey}/auto_dj/current?_=` + Date.now()
  );

  return response.data;
};
